export enum Step {
    ORIGINAL_INPUT = 'ORIGINAL_INPUT',
    SUGGESTIONS = 'SUGGESTIONS',
    GENERATE = 'GENERATE',
    RESULT = 'RESULT',
    PREVIEW = 'PREVIEW',
}

export enum TaskType {
    ASYNC = 'ASYNC',
    SYNC = 'SYNC',
}

export enum AvailableStatus {
    AVAILABLE = 'AVAILABLE',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
}

export enum SupportedLanguage {
    EN = 'EN',
    CN = 'CN',
}

export enum StreamStatus {
    PROGRESS_WITHOUT_DATA = 'PROGRESS_WITHOUT_DATA',
    PROCESSING = 'PROCESSING',
    FINISH = 'FINISH',
    ABORTED = 'ABORTED',
}